"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distance = distance;
exports.distanceSq = distanceSq;
exports.length = length;
exports.lengthSq = lengthSq;
exports.normalize = normalize;
exports.scale = scale;
exports.add = add;
exports.subtract = subtract;
exports.dot = dot;
exports.lerp = lerp;
exports.angle = angle;
exports.rotate = rotate;
exports.clamp = clamp;
exports.randomInCircle = randomInCircle;
exports.isInsideCircle = isInsideCircle;
exports.pointOnCircle = pointOnCircle;
function distance(a, b) {
    const dx = b.x - a.x;
    const dz = b.z - a.z;
    return Math.sqrt(dx * dx + dz * dz);
}
function distanceSq(a, b) {
    const dx = b.x - a.x;
    const dz = b.z - a.z;
    return dx * dx + dz * dz;
}
function length(v) {
    return Math.sqrt(v.x * v.x + v.z * v.z);
}
function lengthSq(v) {
    return v.x * v.x + v.z * v.z;
}
function normalize(v) {
    const len = length(v);
    if (len === 0)
        return { x: 0, z: 0 };
    return { x: v.x / len, z: v.z / len };
}
function scale(v, s) {
    return { x: v.x * s, z: v.z * s };
}
function add(a, b) {
    return { x: a.x + b.x, z: a.z + b.z };
}
function subtract(a, b) {
    return { x: a.x - b.x, z: a.z - b.z };
}
function dot(a, b) {
    return a.x * b.x + a.z * b.z;
}
function lerp(a, b, t) {
    const ct = clamp(t, 0, 1);
    return {
        x: a.x + (b.x - a.x) * ct,
        z: a.z + (b.z - a.z) * ct,
    };
}
function angle(a, b) {
    const dx = b.x - a.x;
    const dz = b.z - a.z;
    return Math.atan2(dz, dx);
}
function rotate(v, rad) {
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    return {
        x: v.x * cos - v.z * sin,
        z: v.x * sin + v.z * cos,
    };
}
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function randomInCircle(radius) {
    const angle = Math.random() * Math.PI * 2;
    const r = radius * Math.sqrt(Math.random());
    return {
        x: r * Math.cos(angle),
        z: r * Math.sin(angle),
    };
}
function isInsideCircle(point, center, radius) {
    return distanceSq(point, center) <= radius * radius;
}
function pointOnCircle(center, radius, rad) {
    return {
        x: center.x + radius * Math.cos(rad),
        z: center.z + radius * Math.sin(rad),
    };
}
//# sourceMappingURL=math2d.js.map